export const SITE = {
  name: "Villa Rosa",
  tagline: "Built to entertain, ready for relaxation.",
  description:
    "Villa Rosa is a sprawling 30-acre vacation and event rental property in the hills of Fallbrook, just outside San Diego, CA. The ideal setting for weddings, retreats, and relaxing getaways.",
  url: "https://villa-rosa-sd.web.app",
  locality: "Fallbrook",
  region: "CA",
  regionName: "California",
  country: "US",
  email: "info@villarosasd.com",
  /** Public-facing inbox used for confirmations; update once confirmed. */
  serviceAreas: ["San Diego", "Fallbrook", "Temecula", "Southern California"],
} as const;

export const PARTNERS = {
  airbnb: "https://www.airbnb.com/rooms/1075571016086220977",
  vrbo: "https://www.vrbo.com/3947507",
} as const;

export const STATS = [
  { value: "30", unit: "acres", label: "30 acres" },
  { value: "3,900+", unit: "sq ft", label: "3,900+ square feet" },
  { value: "4", unit: "bedrooms", label: "4 bedrooms" },
  { value: "3", unit: "full baths", label: "3 full bathrooms" },
] as const;
